var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgBrowser = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 256,
  height: 256,
  fill: "none"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#browser_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#3D3D3D",
  d: "M46.385 20.11v7.5H250.25v44.16h-241V27.61h37.5v-7.5h-45V236h214.665v-7.5H9.25V79.27h241V228.5H216v7.5h41.75V20.11H46.385Z"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 128,
  cy: 154,
  r: 46.5,
  stroke: "#3D3D3D",
  strokeWidth: 7
}), /*#__PURE__*/React.createElement("path", {
  fill: "#3D3D3D",
  d: "M123.033 186.83v-45.912h10v45.912h-10Zm0-55.912v-10h10v10h-10ZM71 53.385H36.566v-7.5H71v7.5Zm-41.934 0h-7.5v-7.5h7.5v7.5Z"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "browser_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h256v256H0z"
})))));
export { SvgBrowser as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjU2IiBoZWlnaHQ9IjI1NiIgdmlld0JveD0iMCAwIDI1NiAyNTYiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxnIGNsaXAtcGF0aD0idXJsKCNjbGlwMCkiPgo8cGF0aCBkPSJNNDYuMzg1IDIwLjExVjI3LjYxSDI1MC4yNVY3MS43N0g5LjI1VjI3LjYxTDQ2Ljc1IDI3LjYxVjIwLjExSDEuNzVWMjM2SDIxNi40MTVWMjI4LjVIOS4yNVY3OS4yN0gyNTAuMjVWMjI4LjVMMjE2IDIyOC41VjIzNkwyNTcuNzUgMjM2VjIwLjExSDQ2LjM4NVoiIGZpbGw9IiMzRDNEM0QiLz4KPGNpcmNsZSBjeD0iMTI4IiBjeT0iMTU0IiByPSI0Ni41IiBzdHJva2U9IiMzRDNEM0QiIHN0cm9rZS13aWR0aD0iNyIvPgo8cGF0aCBkPSJNMTIzLjAzMyAxODYuODNWMTQwLjkxOEgxMzMuMDMzVjE4Ni44M0gxMjMuMDMzWk0xMjMuMDMzIDEzMC45MThWMTIwLjkxOEgxMzMuMDMzVjEzMC45MThIMTIzLjAzM1oiIGZpbGw9IiMzRDNEM0QiLz4KPHBhdGggZD0iTTcwLjk5OTkgNTMuMzg1SDM2LjU2NjRWNDUuODg1SDcwLjk5OTlWNTMuMzg1Wk0yOS4wNjY0IDUzLjM4NUgyMS41NjY0VjQ1Ljg4NUgyOS4wNjY0VjUzLjM4NVoiIGZpbGw9IiMzRDNEM0QiLz4KPC9nPgo8ZGVmcz4KPGNsaXBQYXRoIGlkPSJjbGlwMCI+CjxyZWN0IHdpZHRoPSIyNTYiIGhlaWdodD0iMjU2IiBmaWxsPSJ3aGl0ZSIvPgo8L2NsaXBQYXRoPgo8L2RlZnM+Cjwvc3ZnPgo=";